import Article from "./Article";
import Card from "./Card";
import Faq from "./Faq";
import GuideArticles from "./GuideArticles";
import Image from "./Image";
import Info from "./Info";
import KeyPoints from "./KeyPoints";
import Project from "./Project";
import RichText from "./RichText";

const VARIATION_COMPONENTS = {
  default: RichText,
  richText: RichText,
  image: Image,
  keyPoints: KeyPoints,
  info: Info,
  card: Card,
  guideArticles: GuideArticles,
  article: Article,
  project: Project,
  faq: Faq,
};

/**
 * @typedef {import("@prismicio/client").Content.BlogSlice} BlogSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BlogSlice>} BlogProps
 * @type {import("react").FC<BlogProps>}
 */
const Blog = ({ slice, context }) => {
  const Variation = VARIATION_COMPONENTS[slice.variation];

  // Marqueur Prismic — position gérée par app/layout.js
  if (slice.variation === "portalSumup") {
    return null;
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {Variation && <Variation primary={slice.primary} context={context} />}
    </section>
  );
};

export default Blog;
